import theme from '../../themes/green';

const styles = {
  wrapper: {
    position: 'absolute',
    width: '100%',
    bottom: '0',
    left: 0,
    height: 'calc(100% - 60px)',
    maxHeight: 'calc(100% - 60px)',
    display: 'flex',
    flexFlow: 'column nowrap',
    transition: theme.transitions.slow,
    transform: 'translate(0, 100%)',
  },
  wrapperOpen: {
    transform: 'translate(0, -30px)',
  },
  track: {
    width: 10,
    top: 0,
    right: 0,
    bottom: 0,
  },
  thumb: {
    background: theme.pallete.hover,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '0 0 30px',
  },
  contents: {},
  title: {
    color: theme.pallete.lightTextColor,
    fontFamily: 'Roboto',
    fontWeight: 500,
    padding: 10,
    fontSize: 12,
  },
  accessoryButton: {
    minWidth: 'inherit',
    background: 'red',
    opacity: 1,
    marginTop: 0,
    marginRight: 2,
    marginBottom: 0,
    marginLeft: 0,
    padding: 0,
    width: 30,
    height: 30,
    borderRadius: '0',
    ':hover': {
      opacity: 0.6,
      background: '#C38585',
    },
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/ActionPanel/styles.js